import {
  NodePageDocument,
  UpdateJobCatalogNodeAttributeDocument,
  UpdateJobCatalogNodeAttributeMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import {
  formatUuidToNodeType,
  getChildNodeType,
  getNodeId,
} from 'modules/job_catalog/lib/nodesUtils'

const useUpdateJobCatalogEquipment = () => {
  const [mutate, { loading }] = useMutation(UpdateJobCatalogNodeAttributeDocument, {
    extractorFn: (data: UpdateJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.updateJobcatalogNodeAttribute,
  })

  const updateEquipment = (
    id: number,
    companyId: number,
    nodeUuid: string,
    serializedAttribute: string
  ) => {
    const nodeId = getNodeId(nodeUuid)
    const nodeType = formatUuidToNodeType(nodeUuid)
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        id,
        companyId,
        nodeId,
        nodeType,
        valueJson: serializedAttribute,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid,
            childType,
          },
        },
      ],
    })
  }

  return { updateEquipment, loading }
}

export default useUpdateJobCatalogEquipment
